import voucherHook from "@/domain/use_case/context/voucher/voucher";
import MsRegistrationPoint from "./registration_point";
import { useEffect } from "react";

const RegistrationVoucher = () => {
  const VoucherProvider = voucherHook.Provider;

  useEffect(() => {
    document.title = "Voucher Point";
  }, []);

  return (
    <VoucherProvider>
      <MsRegistrationPoint />
    </VoucherProvider>
  );
};

export default RegistrationVoucher;
